/* Floating WhatsApp button — replaces the previous floating Aria chat.
 * Opens https://wa.me/18089985633 (US business number) in a new tab/app.
 */
export default function WhatsAppFloating() {
  const href = "https://wa.me/18089985633?text=" + encodeURIComponent(
    "Hi WebsiteAndGo — I'd like to chat about my website."
  );
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with WebsiteAndGo on WhatsApp"
      data-testid="floating-whatsapp"
      title="Chat with us on WhatsApp"
      className="fixed bottom-24 lg:bottom-6 right-4 lg:right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] flex items-center justify-center text-white hover:scale-105 active:scale-95 transition-transform focus:outline-none focus:ring-2 focus:ring-[#25D366]/60 focus:ring-offset-2 focus:ring-offset-black"
    >
      {/* Official WhatsApp glyph (inline SVG — no extra deps) */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        aria-hidden="true"
        className="w-7 h-7"
        fill="currentColor"
      >
        <path d="M19.11 17.55c-.27-.14-1.6-.79-1.84-.88-.25-.09-.43-.14-.6.14-.18.27-.69.88-.84 1.06-.16.18-.31.2-.58.07-.27-.14-1.14-.42-2.17-1.34-.8-.72-1.34-1.6-1.5-1.88-.16-.27-.02-.42.12-.56.13-.12.27-.31.4-.47.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.6-1.45-.82-1.98-.22-.52-.44-.45-.6-.46-.16-.01-.34-.01-.52-.01-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.1 2.81.14.18 1.9 2.9 4.6 4.07.64.28 1.14.44 1.54.57.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32zM16 3.2A12.8 12.8 0 0 0 3.2 16c0 2.26.6 4.46 1.74 6.4L3 29l6.75-1.9A12.78 12.78 0 0 0 16 28.8 12.8 12.8 0 0 0 28.8 16 12.8 12.8 0 0 0 16 3.2zm0 23.22a10.4 10.4 0 0 1-5.33-1.47l-.38-.23-3.97 1.11 1.13-3.86-.25-.4A10.42 10.42 0 1 1 16 26.42z" />
      </svg>
    </a>
  );
}
